import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    searchData:""
  },
  getters: {
  },
  mutations: {
    changeSearchData(state,data){
      state.searchData=data
    }
  },
  actions: {
  },
  modules: {
  }
})
